import React, { useEffect, useState } from 'react';
import { ServerInterface } from "src/store/mine_craft/serversSlice";
import { updateServerHostedConfig } from "src/actions/mine_craft/serversActions";
import { useAppDispatch } from "src/store/hooks";

import { Modal, Select, message } from 'antd';
import { BedrockVersions, bedrockVersionOptions } from "./_serverHelpers";

// A build change makes crafty-servers reinstall the server software; the
// server answers `installing` until the `server.ready` that closes it.
// `latest` is resolved at that install, so a server following it still
// falls behind the next Mojang release until it is updated again.
const _VersionForm = ({ server, versions, open, onClose }: {
  server: ServerInterface,
  versions: BedrockVersions,
  open: boolean,
  onClose: () => void
}) => {
  const dispatch = useAppDispatch();
  const requested = server.hosted_server?.config?.version;

  const [version, setVersion] = useState('latest');
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (open) setVersion('latest');
  }, [open]);

  async function apply() {
    setBusy(true);
    const resultAction = await dispatch(updateServerHostedConfig({
      id:   server.id,
      data: { version, restart: true }
    }));
    setBusy(false);

    if (updateServerHostedConfig.fulfilled.match(resultAction)) {
      message.success('Update started — the server is back in a few minutes');
      onClose();
    } else {
      const payload: any = resultAction.payload;
      message.error(Array.isArray(payload) ? payload[0] : 'The update could not be started');
    }
  }

  return (
    <Modal
      title='Bedrock version'
      open={open}
      onCancel={onClose}
      onOk={apply}
      okText='Update'
      okButtonProps={{ loading: busy }}
      destroyOnClose
    >
      <div className='v-srv-power'>
        <div className='o-field'>
          <label>Installed</label>
          <div>
            {server.version || 'unknown'}
            {requested && (requested === 'latest' ? ' · follows latest' : ` · pinned to ${requested}`)}
          </div>
        </div>

        <div className='o-field'>
          <label>Update to</label>
          <Select
            showSearch
            value={version}
            onChange={setVersion}
            options={bedrockVersionOptions(versions)}
          />
        </div>

        <div className='o-hint'>
          Reinstalls the server software on this build and restarts it: players are
          disconnected for a few minutes, worlds, packs and settings stay. Bedrock
          worlds only migrate forward — take a backup before picking a build older
          than the installed one.
        </div>
      </div>
    </Modal>
  );
}

export default _VersionForm;
